import { TableContainer } from "../../../styles";
import { Parte } from "../../../types";

interface CardParteRepresentadaProps {
    parte: Parte;
}

export default function CardParteRepresentada({ parte }: CardParteRepresentadaProps) {
    return (
        <TableContainer>
            <div className="parte-header">PARTE REPRESENTADA</div>
            <table className="data-table">
                <thead>
                    <tr>
                        <th className="field-col">Campo</th>
                        <th className="value-col">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="field-cell">Nome</td>
                        <td className="value-cell">{parte.nome}</td>
                    </tr>
                </tbody>
            </table>
        </TableContainer>
    );
}
